import { Routes, RouterModule } from '@angular/router';
import { HisAuthGuard, HisBootstrapService } from 'hisng';
import { WebTimePageComponent } from './component/webtime/webtime-page.component';
import { WebTimePortletComponent } from './component/webtime/webtime-portlet.component';

export const ROUTE_CONFIG: Routes = [
    {
        // Webzeiterfassung als Seite
        path: 'timemanagement/webtimerecording',
        resolve: { boot: HisBootstrapService },
        component: WebTimePageComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TIMEMANAGEMENT_CREATE_WEB_TIME_RECORD'],
            modules: ['HISINONEZEB']
        }
    },
    {
        // Webzeiterfassung als Portlet
        path: 'timemanagement/webtimerecording/portlet',
        resolve: { boot: HisBootstrapService },
        component: WebTimePortletComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_RM_ERP_TIMEMANAGEMENT_CREATE_WEB_TIME_RECORD'],
            modules: ['HISINONEZEB']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TimeManagementRoutesModule = RouterModule.forChild( ROUTE_CONFIG );
